<!-- Main -->
<div id="main" class="wrapper style1">
  <div class="container tournament">
    <div class="logo-center">
      <div>
        <img src="./assets/images/transparent background_Five.png" alt="" />
      </div>
    </div>
    <header class="major">
      <h2>FIVE ASIDE TOURNAMENT</h2>
      <p>
        is an incredibly fun way of learning about healthy living through Sports
        and Theatre Games Each day is a Super League, Premiership, Championship,
        Euro, Olympic Win! In the mornings we play fun Sports Games based on
        American Football, Basketball, Cricket, Football, Netball and Tennis
        exercises. In the afternoons we play thrilling Theatre Games based on
        Action, Mystery, Spy, Survival, Swashbuckler, Thriller adventures! Have
        Fun! Make New Friends! Win Trophies! Every player is a champion !
      </p>
    </header>
    <!-- Content -->
    <section id="info" class="wrapper style2 special fade tournament">
      <h3>PLAY AWAY</h3>
      <p>
        This Season we we’re taking Players to the New Polka Theatre for a
        Theatre Workshop and Performance- Cinderella The Awesome Truth! Included
        in the Costs.
      </p>

      <h3>LUNCH</h3>
      <p>Lunch is provided</p>

      <h3>COST</h3>
      <p>We have 15 places for free school meals Secondary school students.</p>

      <h3>AGE</h3>
      <p>Key stage 2, 3 and 4</p>

      <h3>DATE</h3>
      <p>December 20th -23rd</p>

      <h3>TIME</h3>
      <p>10:00 a.m. - 3:00 p.m.</p>

      <h3>PITCH</h3>
      <p>Bishop Gilpin CofE Primary School Lake Rd, London SW19 7EP</p>

      <h3>REGISTRATION</h3>
      <p>
        Please register on our website fiveasidetheatre.org (link to
        application)
      </p>

      <h3>COACHES</h3>
      <p>
        All our coaches are fully DBS qualified. Led by experienced Drama
        teachers, Directors, Coaches, Drama facilitators. The young players will
        have the chance to be part of a professional theatre company for a week,
        while building confidence, boosting social skills and sparking their
        imagination.
      </p>

      <div class="logo-center">
        <div>
          <img src="./assets/images/transparent background_Five.png" alt="" />
        </div>
      </div>
    </section>
    <section class="pagedivider">
      <div>&nbsp;</div>
    </section>
    <section id="faq" class="wrapper style2 special fade tournament">
      <h3>FAST Tournament Player information</h3>

      <h3>What is the Five ASide Theatre ?</h3>
      <p>
        Five ASide Theatre is an innovative combination of theatre games and
        sports games that encourage fun, friendship, healthy living and
        confidence. We are inviting Key stage 2,3 and 4 children to join us this
        for a week of theatrical fun, games, trophies and medals.  During the
        Tournament players will be split into Five ASide Theatre Teams to
        compete in Theatre and Sports Games. All genders and abilities welcome.
      </p>
      <p>
        Led by experienced Drama teachers, Directors, Coaches, Drama
        facilitators (all adults Enhanced DBS checked), the young players will
        have the chance to be part of a professional theatre company for a week,
        while building confidence, boosting social skills and sparking their
        imagination.
      </p>
      <p>
        We will provide fun through a variety of exciting games and drama
        activities covering acting, ball sports, characterisation, dancing,
        improvisation, storytelling and more!
      </p>
      <h3>What do we bring and what do the Players wear?</h3>
      <p>
        Please ensure players are prepared for a full day of activity. This
        includes a water bottle, face mask if they’re travelling on public
        transport.
      </p>
      <p>
        Children (players) should wear comfortable, athletic clothes so they can
        play and move. Track suits, t-shirts, shorts, leggings and trainers will
        suffice.
      </p>
      <p>Please ensure they have jacket/coat suitable for the weather.</p>

      <h3>How many places do you have in a Tournament ?</h3>
      <p>This season’s Tournament is limited to 25 players.</p>

      <h3>Do you provide Lunch?</h3>
      <p>
        Lunch will be provided to all players  throughout the week as well as
        refreshments and fruit.
      </p>
      <h3>How do we register for the Five ASide Theatre Tournament?</h3>
      <p>Please complete the registration on this webpage.</p>
      <p>
        Submission of a registration form does not guarantee a place. We will be
        in touch as soon as possible after submission to let you know if we can
        offer your child a place. Places are confirmed upon receipt of a
        confirmation email.
      </p>
      <h3>Are the Coaches qualified?</h3>
      <p>
        Coaches have training in Safeguarding, First Aid, Running Safe
        Activities and Theatre experience. Five ASide Theatre is committed to
        all aspects of safeguarding. All adults at the School will have an
        enhanced DBS check, with a Designated Safeguarding Lead and First Aider
        on site each day.
      </p>

      <h3>What is the ratio of Coaches to players?</h3>
      <p>1:6 With one coach per 6 players everyone gets individual attention</p>

      <h3>What provisions do you have for being Covid-19 secure?</h3>
      <p>
        We will be following official government guidance for the running of
        holiday and after- school activities, and parents/guardians will be
        notified of our procedures.
      </p>
      <h3>Further Questions?</h3>
      <p>Get in touch at fiveasidetheatre@gmail.com</p>

      <div class="logo-center">
        <div>
          <img src="./assets/images/transparent background_Five.png" alt="" />
        </div>
      </div>
    </section>
    <section class="pagedivider">
      <div>&nbsp;</div>
    </section>
    <!-- Four -->
    <section id="application" class="wrapper style2 special fade application">
      <div class="container">
        <header>
          <h2>Application link</h2>
          <p>Five ASide Theatre Tournament Player Registration</p>
        </header>

        <form [formGroup]="personalDetails">
          <!-- progressbar -->
          <div class="nomobile progress-container col-12 col-12-medium">
            <ul id="progressbar" class="progressbar">
              <li [ngClass]="step >= 1 ? 'active ' : 'inactive'">
                Player Details
              </li>
              <li [ngClass]="step >= 2 ? 'active' : 'inactive'">
                Dates you're Attending
              </li>
              <li [ngClass]="step >= 3 ? 'active' : 'inactive'">
                Person with Parental Responsibility
              </li>
              <li [ngClass]="step >= 4 ? 'active ' : 'inactive'">
                Alternative Emergency Contact
              </li>
              <li [ngClass]="step >= 5 ? 'active' : 'inactive'">
                Player's Medical Details
              </li>
              <li [ngClass]="step >= 6 ? 'active' : 'inactive'">
                Player's Dietary Requirements
              </li>
              <li [ngClass]="step >= 7 ? 'active' : 'inactive'">
                Player's Access Requirements
              </li>
              <li [ngClass]="step >= 8 ? 'active' : 'inactive'">
                PHOTO PERMISSION / PLAY AWAY PERMISSION
              </li>
              <li [ngClass]="step >= 9 ? 'active' : 'inactive'">Complete</li>
            </ul>
          </div>

          <div class="mobile progress-container col-12 col-12-medium">
            <ul id="progressbar" class="progressbar">
              <li
                [hidden]="step == 1 || step == 1 + 1 || step == 1 - 1"
                [ngClass]="step >= 1 ? 'active ' : 'inactive'"
              >
                <!--Personal Details-->
              </li>
              <li
                [hidden]="step == 2 || step == 2 + 1 || step == 2 - 1"
                [ngClass]="step >= 2 ? 'active' : 'inactive'"
              >
                <!--dates Attending-->
              </li>
              <li
                [hidden]="step == 3 || step == 3 + 1 || step == 3 - 1"
                [ngClass]="step >= 3 ? 'active' : 'inactive'"
              >
                <!--Parent/Carer Details-->
              </li>
              <li
                [hidden]="step == 4 || step == 4 + 1 || step == 4 - 1"
                [ngClass]="step >= 4 ? 'active ' : 'inactive'"
              >
                <!--Personal Contact Details-->
              </li>
              <li
                [hidden]="step == 5 || step == 5 + 1 || step == 5 - 1"
                [ngClass]="step >= 5 ? 'active' : 'inactive'"
              >
                <!--Alternative Contact Details-->
              </li>
              <li
                [hidden]="step == 6 || step == 6 + 1 || step == 6 - 1"
                [ngClass]="step >= 6 ? 'active' : 'inactive'"
              >
                <!--Medical Details-->
              </li>
              <li
                [hidden]="step == 7 || step == 7 + 1 || step == 7 - 1"
                [ngClass]="step >= 7 ? 'active' : 'inactive'"
              >
                <!--Additional Details-->
              </li>
              <li
                [hidden]="step == 8 || step == 8 + 1 || step == 8 - 1"
                [ngClass]="step >= 8 ? 'active' : 'inactive'"
              >
                <!--Complete-->
              </li>
            </ul>
          </div>

          <div class="col-12 col-12-medium clearfix">
            <!-- fieldsets -->
            <fieldset *ngIf="step == 1">
              <h2 class="fs-title">PLAYER DETAILS</h2>
              <div class="row">
                <div class="col-4 off-4 col-10-small off-1-small">
                  <input
                    type="text"
                    formControlName="name"
                    [ngClass]="{
                      'is-invalid': personal_step && personal.name.errors
                    }"
                    placeholder="Full Name"
                  />
                  <div
                    *ngIf="
                      personal_step && personalDetails.controls.name.errors
                    "
                  >
                    <div *ngIf="personal.name.errors?.required">
                      Name is required
                    </div>
                  </div>
                  <dp-date-picker
                    formControlName="dob"
                    class="ebzdob"
                    placeholder="Date of Birth"
                    #dayPicker
                  ></dp-date-picker>
                  <!--
          <button (click)="open()">Pick Date of Birth</button> 
          <button (click)="close()">Close</button>
          -->

                  <div
                    *ngIf="personal_step && personalDetails.controls.dob.errors"
                  >
                    <div *ngIf="personal.dob.errors?.required">
                      DOB is required
                    </div>
                  </div>

                  <input
                    type="text"
                    formControlName="age"
                    name="age"
                    placeholder="Age"
                  />
                  <div
                    *ngIf="personal_step && personalDetails.controls.age.errors"
                  >
                    <div *ngIf="personal.age.errors?.required">
                      Age is required
                    </div>
                  </div>

                  <input
                    type="text"
                    formControlName="nameofschool"
                    name="nameofschool"
                    placeholder="Name of School"
                  />
                  <div
                    *ngIf="
                      personal_step &&
                      personalDetails.controls.nameofschool.errors
                    "
                  >
                    <div *ngIf="personal.nameofschool.errors?.required">
                      Name of School is required
                    </div>
                  </div>

                  <input
                    (click)="next()"
                    type="button"
                    name="next"
                    class="next action-button"
                    value="Next"
                  />
                </div>
              </div>
            </fieldset>
          </div>
        </form>

        <form [formGroup]="datesAttendingDetails">
          <fieldset *ngIf="step == 2">
            <h2 class="fs-title">DATES YOU'RE ATTENDING</h2>
            <div class="row">
              <div class="col-4 off-3 off-1-small">
                <!--
                <label class="form-container"
                  >All Dates
                  <input
                    type="checkbox"
                    formControlName="alldates"
                    checked="checked"
                  />
                  <span class="checkmark"></span>
                </label>
              -->
                <label class="form-container"
                  >Monday 29th
                  <input type="checkbox" formControlName="monday20th" />
                  <span class="checkmark"></span>
                </label>
                <label class="form-container"
                  >Tuesday 17th
                  <input type="checkbox" formControlName="tuesday21st" />
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="col-4">
                <label class="form-container"
                  >Wednesday 18th
                  <input type="checkbox" formControlName="wednesday22nd" />
                  <span class="checkmark"></span>
                </label>
                <label class="form-container"
                  >Thursday 19th
                  <input type="checkbox" formControlName="thursday23rd" />
                  <span class="checkmark"></span>
                </label>
                <!--
                <label class="form-container"
                  >Friday 20th
                  <input type="checkbox" formControlName="frisday20th" />
                  <span class="checkmark"></span>
                </label>
              --></div>
            </div>

            <input
              (click)="previous()"
              type="button"
              name="previous"
              class="previous action-button-previous"
              value="Previous"
            />
            <input
              (click)="next()"
              type="button"
              name="next"
              class="next action-button"
              value="Next"
            />
          </fieldset>
        </form>

        <form class="applicationForm" [formGroup]="parentCarerDetails">
          <fieldset *ngIf="step == 3">
            <h2 class="fs-title">PERSON WITH PARENTAL RESPONSIBILITY</h2>
            <div class="row">
              <div class="col-6 col-10-small off-1-small">
                <input
                  type="text"
                  formControlName="parentCarerName"
                  name="parentCarerName"
                  placeholder="parentCarerName"
                />
                <div
                  *ngIf="
                    parentCarer_step &&
                    parentCarerDetails.controls.parentCarerName.errors
                  "
                >
                  <div *ngIf="parentCarer.parentCarerName.errors?.required">
                    Parent Carer Name is required
                  </div>
                </div>

                <input
                  type="text"
                  formControlName="relationshipToYP"
                  name="relationshipToYP"
                  placeholder="Relationship To Young Person"
                />
                <div
                  *ngIf="
                    parentCarer_step &&
                    parentCarerDetails.controls.relationshipToYP.errors
                  "
                >
                  <div *ngIf="parentCarer.relationshipToYP.errors?.required">
                    Relationship To Young Person is required
                  </div>
                </div>

                <input
                  type="text"
                  formControlName="parentCarerAddress"
                  name="parentCarerAddress"
                  placeholder="parent Carer Address"
                />
                <div
                  *ngIf="
                    parentCarer_step &&
                    parentCarerDetails.controls.parentCarerAddress.errors
                  "
                >
                  <div *ngIf="parentCarer.parentCarerAddress.errors?.required">
                    parent Carer Address is required
                  </div>
                </div>
              </div>
              <div class="col-6 col-10-small off-1-small">
                <input
                  type="text"
                  formControlName="parentCarerHomeTel"
                  name="parentCarerHomeTel"
                  placeholder="Parent Carer Home Tel"
                />
                <div
                  *ngIf="
                    parentCarer_step &&
                    parentCarerDetails.controls.parentCarerHomeTel.errors
                  "
                >
                  <div *ngIf="parentCarer.parentCarerHomeTel.errors?.required">
                    Parent Carer Home Tel is required
                  </div>
                </div>

                <input
                  type="text"
                  formControlName="parentCarerMobileTel"
                  name="parentCarerMobileTel"
                  placeholder="Parent Carer Mobile Tel"
                />
                <div
                  *ngIf="
                    parentCarer_step &&
                    parentCarerDetails.controls.parentCarerMobileTel.errors
                  "
                >
                  <div
                    *ngIf="parentCarer.parentCarerMobileTel.errors?.required"
                  >
                    Parent Carer Mobile Tel is required
                  </div>
                </div>

                <input
                  type="text"
                  formControlName="parentCarerEmail"
                  name="parentCarerEmail"
                  placeholder="Parent Carer Email"
                />
                <div
                  *ngIf="
                    parentCarer_step &&
                    parentCarerDetails.controls.parentCarerEmail.errors
                  "
                >
                  <div *ngIf="parentCarer.parentCarerEmail.errors?.required">
                    Parent Carer Email is required
                  </div>
                </div>

                <!--
            <input
              type="file"
              accept="image/*" 
              (change)="imagePreview($event)"
              formControlName="parentFreeMeals"
              name="parentFreeMeals"
              placeholder="Parent/Carer Free Meal Evidence"
            />
            <div
              *ngIf="
                parentCarer_step &&
                parentCarerDetails.controls.parentFreeMeals.errors
              "
            >
              <div *ngIf="parentCarer.parentFreeMeals.errors?.required">
                Parent/Carer Free Meal Evidence is required
              </div>
            </div>
          -->
              </div>
            </div>

            <h3>
              Please provide evidence of your free school meals entitlement. We
              will accept
            </h3>
            <ul>
              <li>
                A letter from your secondary school indicating your Free school
                meals entitlement.
              </li>
              <li>
                Attach a photo Your Universal Credit award letter to this
                registration.
              </li>
              <li>
                Attach a screen shot of your free school meals benefits
                entitlement to this registration
              </li>
            </ul>
            <!--
            <div
              class="dropdiv"
              [class.processing]="processing"
              (dragover)="onDragOver($event)"
              (drop)="onDropSuccess($event)"
            >
              <label class="custom-file-upload">
                <input
                  (change)="onChange($event)"
                  formControlName="parentFreeMeals"
                  type="file"
                />
              </label>
            </div>
          -->

            <div class="progress" [class.processing]="processing">
              Processing...
            </div>

            <div *ngIf="filePath && filePath !== ''">
              <img [src]="filePath" [alt]="parentCarerDetails.value.name" />
            </div>

            <input
              (click)="previous()"
              type="button"
              name="previous"
              class="previous action-button-previous"
              value="Previous"
            />
            <input
              (click)="next()"
              type="button"
              name="next"
              class="next action-button"
              value="Next"
            />
          </fieldset>
        </form>

        <form [formGroup]="contactDetails">
          <fieldset *ngIf="step == 4">
            <h2 class="fs-title">ALTERNATIVE EMERGENCY CONTACT</h2>
            <div class="row">
              <div class="col-4 off-4 col-10-small off-1-small">
                <input
                  type="text"
                  formControlName="homeTel"
                  name="homeTel"
                  placeholder="homeTel"
                />
                <div
                  *ngIf="contact_step && contactDetails.controls.homeTel.errors"
                >
                  <div *ngIf="contact.homeTel.errors?.required">
                    home tel is required
                  </div>
                </div>

                <input
                  type="text"
                  formControlName="mobileTel"
                  name="mobileTel"
                  placeholder="mobileTel"
                />
                <div
                  *ngIf="
                    contact_step && contactDetails.controls.mobileTel.errors
                  "
                >
                  <div *ngIf="contact.mobileTel.errors?.required">
                    mobile tel is required
                  </div>
                </div>

                <input
                  type="text"
                  formControlName="email"
                  name="email"
                  placeholder="email"
                />
                <div
                  *ngIf="contact_step && contactDetails.controls.email.errors"
                >
                  <div *ngIf="contact.email.errors?.required">
                    email is required
                  </div>
                </div>
              </div>
            </div>
            <input
              (click)="previous()"
              type="button"
              name="previous"
              class="previous action-button-previous"
              value="Previous"
            />
            <input
              (click)="next()"
              type="button"
              name="next"
              class="next action-button"
              value="Next"
            />
          </fieldset>
        </form>
        <!--
        <form [formGroup]="altContactDetails">
          <fieldset *ngIf="step == 5">
            <h2 class="fs-title">Alternative Contact Details</h2>
            <div class="row">
              <div class="col-4 off-4 col-10-small off-1-small">
                <input
                  type="text"
                  formControlName="altCarerHomeTel"
                  name="altCarerHomeTel"
                  placeholder="alt Carer Home Tel"
                />
                <div
                  *ngIf="
                    altContact_step &&
                    altContactDetails.controls.altCarerHomeTel.errors
                  "
                >
                  <div *ngIf="altContact.altCarerHomeTel.errors?.required">
                    alt Carer Home Tel is required
                  </div>
                </div>

                <input
                  type="text"
                  formControlName="altCarerMobileTel"
                  name="altCarerMobileTel"
                  placeholder="Alt Carer Mobile Tel"
                />
                <div
                  *ngIf="
                    altContact_step &&
                    altContactDetails.controls.altCarerMobileTel.errors
                  "
                >
                  <div *ngIf="altContact.altCarerMobileTel.errors?.required">
                    Alt Carer Mobile Tel is required
                  </div>
                </div>

                <input
                  type="text"
                  formControlName="altCarerEmail"
                  name="altCarerEmail"
                  placeholder="Alt Carer Email"
                />
                <div
                  *ngIf="
                    altContact_step &&
                    altContactDetails.controls.altCarerEmail.errors
                  "
                >
                  <div *ngIf="altContact.altCarerEmail.errors?.required">
                    Alt Carer Email is required
                  </div>
                </div>
              </div>
            </div>

            <input
              (click)="previous()"
              type="button"
              name="previous"
              class="previous action-button-previous"
              value="Previous"
            />
            <input
              (click)="next()"
              type="button"
              name="next"
              class="next action-button"
              value="Next"
            />
          </fieldset>
        </form>
      -->

        <form [formGroup]="medicalDetails">
          <fieldset *ngIf="step == 5">
            <h2 class="fs-title">Players Medical Details</h2>
            <div class="row">
              <div class="col-4 off-3 off-1-small">
                <label class="form-container"
                  >asthma Brochitis
                  <input
                    type="checkbox"
                    formControlName="asthmaBrochitis"
                    checked="checked"
                  />
                  <span class="checkmark"></span>
                </label>
                <label class="form-container"
                  >Allergies
                  <input type="checkbox" formControlName="allergies" />
                  <span class="checkmark"></span>
                </label>
                <label class="form-container"
                  >ADHD
                  <input type="checkbox" formControlName="ADHD" />
                  <span class="checkmark"></span>
                </label>
                <label class="form-container"
                  >Diabetes
                  <input type="checkbox" formControlName="Diabetes" />
                  <span class="checkmark"></span>
                </label>
                <label class="form-container"
                  >HCFFB
                  <input type="checkbox" formControlName="HCFFB" />
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="col-4">
                <label class="form-container"
                  >hayfever
                  <input type="checkbox" formControlName="hayfever" />
                  <span class="checkmark"></span>
                </label>
                <label class="form-container"
                  >headaches
                  <input type="checkbox" formControlName="headaches" />
                  <span class="checkmark"></span>
                </label>
                <label class="form-container"
                  >currentMT
                  <input type="checkbox" formControlName="currentMT" />
                  <span class="checkmark"></span>
                </label>
                <label class="form-container"
                  >other
                  <input type="checkbox" formControlName="other" />
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>

            <input
              (click)="previous()"
              type="button"
              name="previous"
              class="previous action-button-previous"
              value="Previous"
            />
            <input
              (click)="next()"
              type="button"
              name="next"
              class="next action-button"
              value="Next"
            />
          </fieldset>
        </form>

        <form [formGroup]="dietryDetails">
          <fieldset *ngIf="step == 6">
            <h2 class="fs-title">Player's Dietary Requirements</h2>

            <label class="form-container">
              Food allergies and intolerances — such as dairy free, fish and
              shellfish allergies, nut free and gluten free.

              <input type="checkbox" formControlName="foodallergies" />
              <span class="checkmark"></span>
            </label>
            <label class="form-container">
              Special dietary requirements — vegetarian, vegans

              <input type="checkbox" formControlName="veg" />
              <span class="checkmark"></span>
            </label>
            <label class="form-container">
              Religious dietary requirements- Halal, Kosher

              <input type="checkbox" formControlName="foodreligious" />
              <span class="checkmark"></span>
            </label>

            <input
              (click)="previous()"
              type="button"
              name="previous"
              class="previous action-button-previous"
              value="Previous"
            />
            <input
              (click)="next()"
              type="button"
              name="next"
              class="next action-button"
              value="Next"
            />
          </fieldset>
        </form>

        <form [formGroup]="accessDetails">
          <fieldset *ngIf="step == 7">
            <h2 class="fs-title">Player’s Access Requirements</h2>

            <label class="form-container">
              Does your child have additional needs or access requirements that
              you/they would like us to be aware of?
              <input type="checkbox" formControlName="accessRequirement1" />
              <span class="checkmark"></span>
            </label>
            <label class="form-container">
              Do they have any specific needs that need addressing in order for
              them to participate fully in the event i.e. wheelchair access?
              <input type="checkbox" formControlName="accessRequirement1" />
              <span class="checkmark"></span>
            </label>

            <input
              (click)="previous()"
              type="button"
              name="previous"
              class="previous action-button-previous"
              value="Previous"
            />
            <input
              (click)="next()"
              type="button"
              name="next"
              class="next action-button"
              value="Next"
            />
          </fieldset>
        </form>

        <form [formGroup]="permissionDetails">
          <fieldset *ngIf="step == 8">
            <h2 class="fs-title">SAFETY & INTERVENTION</h2>
            <p>
              F.A.S.T aims to provide a safe, secure environment for all young
              people participating in our academies, events and workshops. Risk
              assessments have been undertaken for all activities and all young
              people will be supervised during the academy, event, workshop.
            </p>
            <p>
              Young people participating in our academy, are considered to be
              responsible for their own actions. By signing the this form you
              accept that your child will abide by the rules of the academy;
              failure to do so may result in the young person being excluded
              from the Tournament activities for a part of the day.
            </p>

            <h2 class="fs-title">Photo Permission</h2>

            <p>
              We take photos’ and record videos of our sessions. Before taking
              images of children under the age of 16, we need parental/carer
              permission.
            </p>
            <p>
              We use images of your child for publicity in our online presence,
              social media or on our website, reports and funding reports.
            </p>

            <label class="form-container">
              I do/do not give photo permission for the child named on this
              application.
              <input type="checkbox" formControlName="photoPermission" />
              <span class="checkmark"></span>
            </label>
            <label class="form-container">
              Five ASide Theatre have permission to process and hold information
              <input type="checkbox" formControlName="processPermission" />
              <span class="checkmark"></span>
            </label>

            <input
              (click)="previous()"
              type="button"
              name="previous"
              class="previous action-button-previous"
              value="Previous"
            />
            <input
              (click)="next()"
              type="button"
              name="next"
              class="next action-button"
              value="Next"
            />
          </fieldset>
        </form>

        <form [formGroup]="signatureDetails" (ngSubmit)="onSubmit()">
          <fieldset *ngIf="step == 9">
            <h2 class="fs-title">Parent / Carer Signature</h2>

            <div class="row">
              <div class="col-4 off-4 col-10-small off-1-small">
                <div class="signature-container">
                  <signature-pad
                    [options]="signaturePadOptions"
                    (onBeginEvent)="drawStart()"
                    (onEndEvent)="drawComplete()"
                  ></signature-pad>
                </div>

                <div class="buttons">
                  <input
                    (click)="clearSignature()"
                    type="button"
                    name="previous"
                    value="Clear signature pad"
                  />

                  <input
                    (click)="savePad()"
                    type="button"
                    name="previous"
                    value="Save Signature"
                  />
                </div>

                <div class="signature-image" *ngIf="signatureImg2">
                  <!--<img src="{{ signatureImg }}" />-->
                  SIGNATURE SAVED
                </div>
              </div>
            </div>

            <input
              (click)="previous()"
              type="button"
              name="previous"
              class="previous action-button-previous"
              value="Previous"
            />
            <input
              [disabled]="!signatureImg2"
              type="submit"
              name="submit"
              class="submit action-button"
              value="Submit"
            />
          </fieldset>
        </form>
      </div>
      <a href="#getdirections" class="goto-next scrolly">Next</a>
    </section>
    <section class="pagedivider">
      <div>&nbsp;</div>
    </section>

    
    <section class="pagedivider">
      <div>&nbsp;</div>
    </section>
    <section id="schedule" class="wrapper style2 special fade">
      <h2>Schedule</h2>
      <h3>Monday 21st December</h3>
      <ul>
        <li>Grounds: Bishop Gilpin CofE School Lake Rd, London SW19 7EP</li>
        <li>Kick off: 10:00 a.m.</li>
        <li>Build A Team 10:30-12:30 p.m</li>
        <li>Lunch 12:30 -1:15 p.m</li>
        <li>ChampionShips 1:15-3:00 p.m.</li>
      </ul>

      <h3>Tuesday 22nd December</h3>
      <ul>
        <li>Grounds: Bishop Gilpin CofE School Lake Rd, London SW19 7EP</li>
        <li>Registration: 10:00 a.m.</li>
        <li>Games: 10:30-12:30 p.m</li>
        <li>Lunch 12:30 -1:15 p.m</li>
        <li>Adventure: Escape from No Island 1:15-3:00 p.m.</li>
      </ul>

      <h3>Wednesday 22nd December</h3>
      <ul>
        <li>Polka Theatre, 240 The Broadway, Wimbledon, London SW19 1SB</li>
        <li>Workshop: 11am – 1.00pm</li>
        <li>Lunch: 1.00 - 2.00pm</li>
        <li>Show: 2.30 - 4.30pm Cinderella The Awesome Truth</li>
      </ul>

      <h3>Thursday 23rd December</h3>
      <ul>
        <li>Bishop Gilpin CofE School Lake Rd, London SW19 7EP</li>
        <li>Registration: 10:00 a.m.</li>
        <li>Games: 10:30-12:30 p.m</li>
        <li>Lunch: 12:30 -1:15 p.m</li>
        <li>Adventure: Mission Inconquerable 1:15-3:00 p.m.</li>
      </ul>
    </section>
    <section class="pagedivider">
      <div>&nbsp;</div>
    </section>
    <section id="feedback" class="wrapper style2 special fade tournament">
      <h2>Feedback From Our Last Five ASide Theatre Tournament</h2>
      <h3>Parents feedback</h3>
      <p>
        <i
          >Hi I’m Brandi one of the parents of the children that attended Five
          ASide Theatre Summer Programme. My children really enjoyed it. It was
          very good for their character development. They had fun there was lots
          of provision for the children and I look forward to them having
          another opportunity to attend. Thank You.
        </i>
      </p>
      <p>
        <i
          >Good afternoon. I’m a parent of a few of the children that attended
          the Five ASide Theatre Summer camp. I’d just like to express how
          wonderful an opportunity it was. My children came in the first day and
          couldn’t wait to attend the following days. Even so much so that they
          told their friends about it. They’ve been Going on and on how
          wonderful activities that have been laid on for them. There was sport,
          there’s been acting, there are awards, a lovely meal laid on for them
          each day. Different menu choices. I’d like to see more of this during
          the year. I’m looking forward to the next available opportunity. So
          thank you so much Five ASide Theatre. You’re a great team. I’m so glad
          to have met you guys. Than you.
        </i>
      </p>
      <h3>Parents Feedback</h3>
      <ul class="feedback">
        <li>
          Player 1 The reason why I like Five ASide Theatre…. there’s a place
          where Mums and Dads can relax and the kids will have fun and the
          Parents will have fun as well. It’s a really welcome place as well.
          You’ll never get left out.
        </li>
        <li>
          Player 2 It was good because it helped me focus on things that could
          help make me a better person in life.
        </li>
        <li>
          Player 3 FAST helped me focus on being a better person and also the
          coaches are very caring.
        </li>
        <li>
          Player 4 what I liked about Five ASide Theate are the activities.
        </li>
        <li>Player 5 I liked about Five ASide are the games.</li>
        <li>Player 6 I liked how it made me feel welcome on the first day.</li>
        <li>
          Player 7 Five ASide Theatre helped me to not only think about Winning
          or other stuff that you would actually win in other games but actually
          thinking about the different qualities that we need to develop our
          skills in life to help us move on.
        </li>

        <li>
          Player 8 I like Five ASide Theatre because it’s very interesting.
        </li>
        <li>
          Player 9 Five ASide Theatre makes you feel included and at home. The
          teachers are always there when you need them. They care for you.
        </li>
      </ul>

      <div class="logo-center">
        <div>
          <img src="./assets/images/transparent background_Five.png" alt="" />
        </div>
      </div>
    </section>

  </div>
</div>
